import XeroDisconnectButtonIcon from './XeroDisconnectButtonIcon';

export default XeroDisconnectButtonIcon;
